exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-7a683494] {\n  width: 48px;\n  height: 48px;\n  display: inline-block;\n  position: relative;\n}\n.loader[data-v-7a683494]::after,\n.loader[data-v-7a683494]::before {\n  content: \"\";\n  box-sizing: border-box;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: #DEDEDE;\n  position: absolute;\n  left: 0;\n  top: 0;\n  animation: animloader-data-v-7a683494 2s linear infinite;\n}\n@keyframes animloader-data-v-7a683494 {\n0% {\n    transform: scale(0);\n    opacity: 1;\n}\n100% {\n    transform: scale(1);\n    opacity: 0;\n}\n}", ""]);

// exports
